import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import * as color from '@constant/color';
import * as size from '@constant/size';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/gridgio/modal-slice';
import ModalTemplate from '@component/common/modal/modal-template';
import FeaturePlannedModal from '@component/common/modal/feature-planned-modal';
import SourceCreateModal from '@component/gridgio/modal/dialog-modal/source-create-modal';
import PlanCreateModal from '@component/gridgio/modal/dialog-modal/plan-create-modal';
import PlanRemoveModal from '@component/gridgio/modal/dialog-modal/plan-remove-modal';
import PlanEditModal from '@component/gridgio/modal/dialog-modal/plan-edit-modal';
import ProjectEditModal from '@component/gridgio/modal/dialog-modal/project-edit-modal';
import ProjectRemoveModal from '@component/gridgio/modal/dialog-modal/project-remove-modal';
import ProjectBookmarkRemoveModal from '@component/gridgio/modal/dialog-modal/project-bookmark-remove-modal';
import ProjectCreateModal from '@component/gridgio/modal/dialog-modal/project-create-modal';
import StartWorkModal from '@component/gridgio/modal/dialog-modal/start-work-modal';
import CreateWorkModal from '@component/gridgio/modal/dialog-modal/create-work-modal';
import WorkEditModal from '@component/gridgio/modal/dialog-modal/work-edit-modal';
import WorkRemoveModal from '@component/gridgio/modal/dialog-modal/work-remove-modal';
import FileSavedModal from '@component/gridgio/modal/dialog-modal/file-saved-modal';
import AnnotationModal from '@component/gridgio/modal/dialog-modal/annotation-modal';
import MapPreviewModal from '@component/gridgio/modal/dialog-modal/map-preview-modal';
import PlanPreviewModal from '@component/gridgio/modal/dialog-modal/plan-preview-modal';
import {
  isFileSavedModalDataType,
  isPlainTextModalDataType,
  isFeaturePlannedModalDataType,
  isSourceCreateModalDataType,
  isPlanCreateModalDataType,
  isPlanRemoveModalDataType,
  isPlanEditModalDataType,
  isProjectCreateModalDataType,
  isProjectEditModalDataType,
  isProjectRemoveModalDataType,
  isProjectBookmarkRemoveModalDataType,
  isStartWorkModalDataType,
  isCreateWorkModalDataType,
  isWorkEditModalDataType,
  isWorkRemoveModalDataType,
  isSourcePreviewModalDataType,
  isPlanPreviewModalDataType,
  isMapPreviewModalDataType,
  isAnnotationModalDataType,
} from '@datatype/gridgio/type';

const PlainTextModalContainer = styled.div`
  width: ${size.MEDIUM_MODAL_WIDTH};
`;

const DialogModal = () => {
  const dispatch = useTypedDispatch();
  const dialogModalData = useTypedSelector((state) => state.rootReducer?.gridgioModalReducer?.dialogModalData) || null;
  const handleClose = () => {
    if (isFeaturePlannedModalDataType(dialogModalData) && dialogModalData.data?.returnTo) {
      dispatch(modalActions.showDialogModal(dialogModalData.data.returnTo));
      return;
    }
    dispatch(modalActions.hideModal());
  };

  return (
    <ModalTemplate hideLogo={!isFeaturePlannedModalDataType(dialogModalData)} onClose={handleClose}>
      {isFileSavedModalDataType(dialogModalData) && <FileSavedModal data={dialogModalData.data} />}
      {isPlainTextModalDataType(dialogModalData) && (
        <PlainTextModalContainer>
          <TextBlock text={dialogModalData.data} design={{ text: { size: 'medium', color: color.BLACK_2 } }} />
        </PlainTextModalContainer>
      )}
      {isFeaturePlannedModalDataType(dialogModalData) && <FeaturePlannedModal handleClose={handleClose} />}
      {isSourceCreateModalDataType(dialogModalData) && <SourceCreateModal />}
      {isPlanCreateModalDataType(dialogModalData) && <PlanCreateModal data={dialogModalData.data} />}
      {isPlanEditModalDataType(dialogModalData) && <PlanEditModal data={dialogModalData.data} />}
      {isPlanRemoveModalDataType(dialogModalData) && <PlanRemoveModal data={dialogModalData.data} />}
      {isProjectEditModalDataType(dialogModalData) && (
        <ProjectEditModal key={dialogModalData.data.key} data={dialogModalData.data} />
      )}
      {isProjectRemoveModalDataType(dialogModalData) && (
        <ProjectRemoveModal key={dialogModalData.data.projectKey} data={dialogModalData.data} />
      )}
      {isProjectBookmarkRemoveModalDataType(dialogModalData) && (
        <ProjectBookmarkRemoveModal key={dialogModalData.data.projectKey} data={dialogModalData.data} />
      )}
      {isProjectCreateModalDataType(dialogModalData) && <ProjectCreateModal />}
      {isStartWorkModalDataType(dialogModalData) && <StartWorkModal data={dialogModalData.data} />}
      {isCreateWorkModalDataType(dialogModalData) && <CreateWorkModal data={dialogModalData.data} />}
      {isWorkEditModalDataType(dialogModalData) && (
        <WorkEditModal key={dialogModalData.data.workKey} data={dialogModalData.data} />
      )}
      {isWorkRemoveModalDataType(dialogModalData) && (
        <WorkRemoveModal key={dialogModalData.data.workKey} data={dialogModalData.data} />
      )}
      {isMapPreviewModalDataType(dialogModalData) && <MapPreviewModal data={dialogModalData.data} />}
      {isAnnotationModalDataType(dialogModalData) && <AnnotationModal data={dialogModalData.data} />}
      {(isSourcePreviewModalDataType(dialogModalData) || isPlanPreviewModalDataType(dialogModalData)) && (
        <PlanPreviewModal data={dialogModalData.data} />
      )}
    </ModalTemplate>
  );
};
export default DialogModal;
